import colors from "../base/colors";
import boxShadows from "../base/boxShadows";

import rgba from "../functions/rgba";

const { white, transparent, grey } = colors;

const appBar = {
  defaultProps: {
    elevation: 0,
  },

  styleOverrides: {
    root: {
      backgroundColor: rgba(white.main, 0.95),
      backdropFilter: "blur(10px)",
      borderBottom: `1px solid ${rgba(grey[200], 0.8)}`,
      boxShadow: boxShadows.sm,
      color: grey[700],
      padding: "0.5rem 1.5rem",
      transition: "all 0.2s cubic-bezier(0.4, 0, 0.2, 1)",

      "& .MuiToolbar-root": {
        minHeight: "auto",
        padding: 0,
      },

      "&.MuiAppBar-colorPrimary": {
        backgroundColor: rgba(white.main, 0.95),
        color: grey[700],
      },
    },

    colorPrimary: {
      backgroundColor: rgba(white.main, 0.95),
      color: grey[700],
    },

    colorSecondary: {
      backgroundColor: rgba(white.main, 0.95),
      color: grey[700],
    },

    colorInherit: {
      backgroundColor: rgba(white.main, 0.95),
      color: grey[700],
    },

    colorTransparent: {
      backgroundColor: transparent.main,
      color: grey[700],
      boxShadow: "none",
      borderBottom: "none",
    },
  },
};

export default appBar;
